import { useEffect } from 'react';
import { useTemplateEditorState } from '../context/UseTemplateEditorContext';

const delayValue = 4000; // milliseconds

export const useListenForTemplateChange = (previewTemplate: () => void) => {
  const { template } = useTemplateEditorState();

  useEffect(() => {
    const timer = setTimeout(previewTemplate, delayValue);
    return () => clearTimeout(timer);
  }, [template, previewTemplate]);
};
